import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

function keepScroll() {
  if (typeof window === "undefined") return
  const y = window.scrollY
  const pin = () => window.scrollTo(0, y)
  pin()
  window.requestAnimationFrame(pin)
  window.setTimeout(pin, 0)
  window.setTimeout(pin, 80)
}

export const Pagination = ({ isFirst, isLast, prevPage, nextPage }) => {
  return (
    <PaginationWrapper>
      {isFirst ? (
        <Disabled>Föregående sida</Disabled>
      ) : (
        <PaginationElement to={prevPage} onClick={keepScroll}>
          Föregående sida
        </PaginationElement>
      )}
      {isLast || !nextPage ? (
        <Disabled>Nästa sida</Disabled>
      ) : (
        <PaginationElement to={nextPage} onClick={keepScroll}>
          Nästa sida
        </PaginationElement>
      )}
    </PaginationWrapper>
  )
}

const PaginationWrapper = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  padding: 3rem 0 1rem;
  font-size: 0.875rem;
`

const PaginationElement = styled(Link)`
  color: var(--fg);
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: underline;
    text-underline-offset: 0.2em;
  }
`

const Disabled = styled.span`
  color: var(--muted);
  opacity: 0.7;
`
